import { JwtModel } from './../models/JwtModel';
import { createStore } from "vuex";
import createPersistedState from 'vuex-persistedstate';
import  {OauthModel} from '@/models/OauthModel';
import { UserInfoModel } from '@/models/UserInfoModel';
import {SPModel} from '@/models/SPModel';
import { MenuModel } from "@/models/MenuModel";
export default createStore({
  strict: true,
  state: {
    isSidebarMinimized: false,
    code: {} as OauthModel,
    jwt: {} as JwtModel,
    userInfo: {} as UserInfoModel,
    arr_sp: [],
    mainMenu:[] as MenuModel[],
    sp:{} as SPModel
  },
  plugins: [createPersistedState()],
  getters: {},
  mutations: {
    updateSidebarCollapsedState(state, isSidebarMinimized) {
      state.isSidebarMinimized = isSidebarMinimized
    },
    UpdateCode(state, value){     
      state.code =  Object.assign({} as OauthModel, value)
    },
    UpdateUserInfo(state, value){
      state.userInfo =  Object.assign({} as UserInfoModel, value)
    },
    UpdateJwt(state, value){
      state.jwt =  Object.assign({} as JwtModel, value)
    },
    UpdateSP(state, value){
      state.arr_sp =  value
    },
    Select_sp(state, value){
      state.sp = Object.assign({}, value);
    },
    addMenu(state, value){
      state.mainMenu = value;
    },
    logOut (state, value) {
      state.code = Object.assign({}, {} as OauthModel);
      state.jwt = Object.assign({}, {} as JwtModel);
      state.userInfo = Object.assign({}, {} as UserInfoModel);
      state.arr_sp = [];
      state.sp =  Object.assign({}, {} as SPModel);
      state.mainMenu = [];
    },
  },
  actions: {},
  modules: {},
});
